module.exports = __webpack_public_path__ + "static/undraw_booking-68bd4437cc72548d7b34528a05e9f207.svg";